import PropTypes from 'prop-types';
import { useCallback } from 'react';
import useContentSearch from '../prosemirror/utils/useContentSearch';
import ContentTypeahead from './ContentTypeahead';
import { jsx as _jsx } from "react/jsx-runtime";
function ContentTypeaheadContainer({
  // @ts-expect-error ts-migrate FIXME
  ErrorState,
  // @ts-expect-error ts-migrate FIXME
  EmptyState,
  // @ts-expect-error ts-migrate FIXME
  onChange,
  // @ts-expect-error ts-migrate FIXME
  portalId,
  // @ts-expect-error ts-migrate FIXME
  searchPlaceHolder,
  // @ts-expect-error ts-migrate FIXME
  search,
  // @ts-expect-error ts-migrate FIXME
  transformData
}) {
  const [__data, searchQuery, setSearchQuery, options, isLoading] = useContentSearch(search, transformData);
  const handleSearch = useCallback(e => setSearchQuery(e.target.value), [setSearchQuery]);
  return /*#__PURE__*/_jsx(ContentTypeahead, {
    portalId: portalId,
    ErrorState: ErrorState,
    EmptyState: EmptyState,
    search: searchQuery,
    handleSearch: handleSearch,
    isLoading: isLoading
    // @ts-expect-error ts-migrate FIXME
    ,
    options: options,
    searchPlaceHolder: searchPlaceHolder,
    onChange: onChange
  });
}
ContentTypeaheadContainer.propTypes = {
  ErrorState: PropTypes.elementType.isRequired,
  EmptyState: PropTypes.elementType.isRequired,
  onChange: PropTypes.func,
  portalId: PropTypes.number.isRequired,
  searchPlaceHolder: PropTypes.string.isRequired,
  search: PropTypes.func,
  transformData: PropTypes.func.isRequired
};
export default ContentTypeaheadContainer;